/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
};

export type AddStockInput = {
  locationId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  shopId: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  landmark: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  landmark: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

export type AdjustInventoryInput = {
  locationId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  quantityChange: Scalars['Float']['input'];
  shopId: Scalars['String']['input'];
  transactionType: Scalars['String']['input'];
};

export type BillSettings = {
  __typename?: 'BillSettings';
  accentColor: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  footerText: Scalars['String']['output'];
  gstin?: Maybe<Scalars['String']['output']>;
  hasLogo: Scalars['Boolean']['output'];
  headerNote?: Maybe<Scalars['String']['output']>;
  logoUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  printedName: Scalars['String']['output'];
  receiptPaper: ReceiptPaper;
  show: BillSettingsShowEffective;
};

export type BillSettingsInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  gstin?: InputMaybe<Scalars['String']['input']>;
  headerNote?: InputMaybe<Scalars['String']['input']>;
  printedName?: InputMaybe<Scalars['String']['input']>;
  receiptPaper?: InputMaybe<ReceiptPaper>;
  show?: InputMaybe<BillSettingsShowInput>;
};

export type BillSettingsShowEffective = {
  __typename?: 'BillSettingsShowEffective';
  address: Scalars['Boolean']['output'];
  customerPhone: Scalars['Boolean']['output'];
  discountColumn: Scalars['Boolean']['output'];
  email: Scalars['Boolean']['output'];
  gstin: Scalars['Boolean']['output'];
  paymentMethod: Scalars['Boolean']['output'];
  phone: Scalars['Boolean']['output'];
  staff: Scalars['Boolean']['output'];
};

export type BillSettingsShowInput = {
  address?: InputMaybe<Scalars['Boolean']['input']>;
  customerPhone?: InputMaybe<Scalars['Boolean']['input']>;
  discountColumn?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  gstin?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  staff?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A location's effective business profile: its kind's preset with the location's overrides applied. */
export type BusinessProfile = {
  __typename?: 'BusinessProfile';
  servicesEnabled: Scalars['Boolean']['output'];
  servicesLabel: Scalars['String']['output'];
  staffLabel: Scalars['String']['output'];
  staffPerLine: StaffPerLine;
};

export type BusinessProfileOverrides = {
  __typename?: 'BusinessProfileOverrides';
  servicesEnabled?: Maybe<Scalars['Boolean']['output']>;
  servicesLabel?: Maybe<Scalars['String']['output']>;
  staffLabel?: Maybe<Scalars['String']['output']>;
  staffPerLine?: Maybe<StaffPerLine>;
};

export type BusinessProfileOverridesInput = {
  servicesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  servicesLabel?: InputMaybe<Scalars['String']['input']>;
  staffLabel?: InputMaybe<Scalars['String']['input']>;
  staffPerLine?: InputMaybe<StaffPerLine>;
};

export type BusinessProfilePreset = {
  __typename?: 'BusinessProfilePreset';
  businessType: BusinessType;
  profile: BusinessProfile;
};

export enum BusinessType {
  FoodDelivery = 'FOOD_DELIVERY',
  OtherServices = 'OTHER_SERVICES',
  Salon = 'SALON'
}

export type CategoryRevenue = {
  __typename?: 'CategoryRevenue';
  categoryId?: Maybe<Scalars['String']['output']>;
  categoryName: Scalars['String']['output'];
  count: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
};

export type CommissionReportSummary = {
  __typename?: 'CommissionReportSummary';
  stylistReports: Array<StylistCommissionReport>;
  totalCommissionAmount: Scalars['Float']['output'];
  totalSalesAmount: Scalars['Float']['output'];
  totalStylists: Scalars['Float']['output'];
};

export type ComparisonMetrics = {
  __typename?: 'ComparisonMetrics';
  dayOverDay?: Maybe<Scalars['Float']['output']>;
  monthOverMonth?: Maybe<Scalars['Float']['output']>;
  previousPeriodSales?: Maybe<Scalars['Float']['output']>;
  weekOverWeek?: Maybe<Scalars['Float']['output']>;
};

export type CopyHairServicesResult = {
  __typename?: 'CopyHairServicesResult';
  copied: Scalars['Int']['output'];
  /** Names already at the target, left as they were. */
  skipped: Array<Scalars['String']['output']>;
};

/** Customer object */
export type Customer = {
  __typename?: 'Customer';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  shopId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

/** Customer input */
export type CustomerInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};

export type CustomerListInput = {
  createdFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shopId: Scalars['String']['input'];
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  city: Scalars['String']['output'];
  directions?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  longitude: Scalars['Float']['output'];
  pincode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type DeliveryAddressInput = {
  city: Scalars['String']['input'];
  directions?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude: Scalars['Float']['input'];
  pincode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryAuthPayload = {
  __typename?: 'DeliveryAuthPayload';
  customer: DeliveryCustomer;
  isNewCustomer: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
};

export type DeliveryCartItemInput = {
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type DeliveryCustomer = {
  __typename?: 'DeliveryCustomer';
  createdAt: Scalars['DateTimeISO']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastLoginAt?: Maybe<Scalars['DateTimeISO']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DeliveryCustomerProfileInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type DeliveryLocation = {
  __typename?: 'DeliveryLocation';
  acceptsCashOnDelivery: Scalars['Boolean']['output'];
  baseFee: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deliveryRadiusKm: Scalars['Float']['output'];
  driverPerKmRate: Scalars['Float']['output'];
  fleetModel: FleetModel;
  id: Scalars['Int']['output'];
  isDeliveryEnabled: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  locationId: Scalars['String']['output'];
  longitude: Scalars['Float']['output'];
  minFee: Scalars['Float']['output'];
  paymentConnection?: Maybe<DeliveryPaymentConnection>;
  perKmRate: Scalars['Float']['output'];
  shopId: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type DeliveryLocationConfigInput = {
  acceptsCashOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  baseFee?: InputMaybe<Scalars['Float']['input']>;
  deliveryRadiusKm: Scalars['Float']['input'];
  driverPerKmRate: Scalars['Float']['input'];
  fleetModel: FleetModel;
  isDeliveryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  locationId: Scalars['String']['input'];
  longitude: Scalars['Float']['input'];
  minFee?: InputMaybe<Scalars['Float']['input']>;
  perKmRate?: InputMaybe<Scalars['Float']['input']>;
};

export type DeliveryOrder = {
  __typename?: 'DeliveryOrder';
  addressSnapshot?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  deliveryFee: Scalars['Float']['output'];
  distanceKm?: Maybe<Scalars['Float']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  estimatedMinutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  items: Array<DeliveryOrderItem>;
  locationId: Scalars['String']['output'];
  orderType: Scalars['String']['output'];
  payment?: Maybe<DeliveryPayment>;
  paymentMethod: Scalars['String']['output'];
  placedAt: Scalars['DateTimeISO']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type DeliveryOrderItem = {
  __typename?: 'DeliveryOrderItem';
  id: Scalars['Int']['output'];
  lineTotal: Scalars['Float']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

export enum DeliveryOtpIntent {
  Login = 'LOGIN',
  Register = 'REGISTER'
}

export type DeliveryOtpRequestResult = {
  __typename?: 'DeliveryOtpRequestResult';
  accountExists: Scalars['Boolean']['output'];
  expiresInSeconds: Scalars['Int']['output'];
  otpLength: Scalars['Int']['output'];
  resendAfterSeconds: Scalars['Int']['output'];
  sent: Scalars['Boolean']['output'];
};

export type DeliveryPayment = {
  __typename?: 'DeliveryPayment';
  amount: Scalars['Float']['output'];
  amountPaise: Scalars['Int']['output'];
  capturedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  currency: Scalars['String']['output'];
  gatewayOrderId: Scalars['String']['output'];
  method?: Maybe<Scalars['String']['output']>;
  provider: PaymentProvider;
  publicToken?: Maybe<Scalars['String']['output']>;
  refundedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status: DeliveryPaymentStatus;
};

export type DeliveryPaymentConnection = {
  __typename?: 'DeliveryPaymentConnection';
  connectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disconnectedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  provider: PaymentProvider;
  razorpayAccountId?: Maybe<Scalars['String']['output']>;
  status: PaymentConnectionStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
};

export enum DeliveryPaymentStatus {
  Captured = 'CAPTURED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Refunded = 'REFUNDED',
  RefundFailed = 'REFUND_FAILED',
  RefundPending = 'REFUND_PENDING'
}

export type DeliveryProduct = {
  __typename?: 'DeliveryProduct';
  availableQuantity: Scalars['Int']['output'];
  categoryId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  images: Array<Scalars['String']['output']>;
  isInStock: Scalars['Boolean']['output'];
  isPerishable: Scalars['Boolean']['output'];
  locationId: Scalars['String']['output'];
  maxOrderQuantity?: Maybe<Scalars['Int']['output']>;
  minOrderQuantity: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  preparationTime?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  shelfLifeDays?: Maybe<Scalars['Int']['output']>;
  shopId: Scalars['String']['output'];
  taxPercentage: Scalars['Float']['output'];
  unit: ProductUnit;
};

export type DeliveryProductPage = {
  __typename?: 'DeliveryProductPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<DeliveryProduct>;
  total: Scalars['Int']['output'];
};

export enum DiscountType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type Expense = {
  __typename?: 'Expense';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  shopId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ExpenseInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  shopId: Scalars['String']['input'];
};

export enum FleetModel {
  Freelance = 'FREELANCE',
  OwnFleet = 'OWN_FLEET'
}

export type GetUserEventsInput = {
  allShops?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  eventType?: InputMaybe<UserEventType>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type HairService = {
  __typename?: 'HairService';
  _id?: Maybe<Scalars['String']['output']>;
  commissionPercentage?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description: Scalars['String']['output'];
  duration_minutes: Scalars['Float']['output'];
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  shopId: Scalars['String']['output'];
  taxPercentage?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type HairServiceInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  commissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration_minutes: Scalars['Float']['input'];
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  shopId: Scalars['String']['input'];
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type Inventory = {
  __typename?: 'Inventory';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Float']['output'];
  lastRestockedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  locationId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  quantityAvailable: Scalars['Float']['output'];
  quantityOnHand: Scalars['Float']['output'];
  quantityReserved: Scalars['Float']['output'];
  reorderLevel: Scalars['Float']['output'];
  reorderQuantity: Scalars['Float']['output'];
  shopId: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type InventoryAnalysisItem = {
  __typename?: 'InventoryAnalysisItem';
  currentStock: Scalars['Float']['output'];
  daysUntilStockout?: Maybe<Scalars['Float']['output']>;
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  quantityAvailable: Scalars['Float']['output'];
  quantityReserved: Scalars['Float']['output'];
  reorderLevel?: Maybe<Scalars['Float']['output']>;
  status: StockStatus;
  usageInPeriod: Scalars['Float']['output'];
};

export type InventoryTransaction = {
  __typename?: 'InventoryTransaction';
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  inventoryId: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  quantityAfter: Scalars['Float']['output'];
  quantityBefore: Scalars['Float']['output'];
  quantityChange: Scalars['Float']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceType?: Maybe<Scalars['String']['output']>;
  transactionType: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  _id?: Maybe<Scalars['String']['output']>;
  address: Address;
  businessType?: Maybe<BusinessType>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ISO 4217 code of the currency this location bills in. */
  currency: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  printerName: Scalars['String']['output'];
  /** The kind's preset with this location's overrides applied. Computed, never stored. */
  profile: BusinessProfile;
  profileOverrides?: Maybe<BusinessProfileOverrides>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type LocationBase = {
  _id?: InputMaybe<Scalars['String']['input']>;
  address: AddressInput;
  businessType?: InputMaybe<BusinessType>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  printerName: Scalars['String']['input'];
  profileOverrides?: InputMaybe<BusinessProfileOverridesInput>;
};

export type MessagingQueueStatsObject = {
  __typename?: 'MessagingQueueStatsObject';
  completed: Scalars['Float']['output'];
  failed: Scalars['Float']['output'];
  pending: Scalars['Float']['output'];
  processing: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addLocationToShop: Shop;
  addShop: Shop;
  addStock: Inventory;
  addUpdateCustomer?: Maybe<Customer>;
  addUpdateExpense?: Maybe<Expense>;
  addUpdateHairService?: Maybe<HairService>;
  addUpdateOrder?: Maybe<Order>;
  addUpdateProduct?: Maybe<Product>;
  addUpdateUser?: Maybe<User>;
  adjustInventory: Inventory;
  /** Cancel an order that has not started being prepared. Reserved stock is released. */
  cancelDeliveryOrder: DeliveryOrder;
  cleanupExpiredReservations: Scalars['Float']['output'];
  /** Create or replace a location's delivery settings. Validates that the location exists and that the coordinates are real. */
  configureDeliveryLocation: DeliveryLocation;
  /** Tell the server the app's Razorpay checkout succeeded. The payment is verified with Razorpay before the order moves on; the webhook would move it anyway, this only makes it immediate. */
  confirmDeliveryPayment: DeliveryOrder;
  copyHairServices: CopyHairServicesResult;
  deleteCustomer?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete an address. Orders already placed to it are unaffected. */
  deleteDeliveryAddress: Scalars['Boolean']['output'];
  deleteExpense?: Maybe<Scalars['Boolean']['output']>;
  deleteHairService?: Maybe<Scalars['Boolean']['output']>;
  deleteLocation: Scalars['Boolean']['output'];
  deleteOrder?: Maybe<Scalars['Boolean']['output']>;
  deleteProduct?: Maybe<Scalars['Boolean']['output']>;
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  /** A link to Razorpay's hosted checkout for an order that is waiting to be paid, for the app to open in the system browser where the native checkout is not available. Valid for 15 minutes; Razorpay sends the customer back to `returnUrl`, which must be an app link. */
  deliveryPaymentCheckoutUrl: Scalars['String']['output'];
  /** Disconnect a location's Razorpay account. Refused while cash on delivery is switched off, or customers would have no way to pay. */
  disconnectRazorpay: DeliveryLocation;
  /** Exit impersonation mode and return to original user */
  exitImpersonation: Scalars['String']['output'];
  generateOtp: Scalars['Boolean']['output'];
  getMessagingQueueStats: MessagingQueueStatsObject;
  /** Impersonate a user by phone number (Super Admin only) */
  impersonateUser: Scalars['String']['output'];
  login?: Maybe<Scalars['String']['output']>;
  logout: Scalars['Boolean']['output'];
  /** Place an order. The cart is re-priced and re-checked against live stock; client-supplied prices are discarded. */
  placeDeliveryOrder: DeliveryOrder;
  queueBillToWhatsApp: Scalars['Boolean']['output'];
  /** Register this device's Expo push token for the signed-in delivery customer. Returns false if the token is not a valid Expo push token. */
  registerDeliveryDevice: Scalars['Boolean']['output'];
  removeBillLogo: BillSettings;
  /** Send a login/registration OTP to a delivery customer's phone. */
  requestDeliveryOtp: DeliveryOtpRequestResult;
  saveBillSettings: BillSettings;
  /** Create an address, or update one the caller owns. The first address saved becomes the default. */
  saveDeliveryAddress: DeliveryAddress;
  savePrinterName: Scalars['String']['output'];
  saveProductCategory: ProductCategory;
  /** Make one address the default, clearing the previous one. */
  setDefaultDeliveryAddress: DeliveryAddress;
  /** Grant or revoke a location's delivery capability. Super Admin only. The stored configuration is left intact, so delivery can be switched back on without re-entering it. */
  setDeliveryLocationEnabled: DeliveryLocation;
  /** Start connecting a location to the restaurant's own Razorpay account. Returns the Razorpay authorisation URL to open; Razorpay sends the user back to the portal when they finish. The link is valid for 15 minutes. */
  startRazorpayConnect: Scalars['String']['output'];
  switchShop: Scalars['Boolean']['output'];
  toggleShopStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Stop sending push notifications to this device. Called on sign-out. */
  unregisterDeliveryDevice: Scalars['Boolean']['output'];
  /** Update the signed-in delivery customer's profile. Requires a delivery customer token. */
  updateDeliveryCustomerProfile: DeliveryCustomer;
  /** Advance a delivery order to its next status. */
  updateDeliveryOrderStatus: DeliveryOrder;
  updateLocation?: Maybe<Shop>;
  updateShop?: Maybe<Shop>;
  /** PNG, JPEG or WebP, at most 300 KB, as a data URL. */
  uploadBillLogo: BillSettings;
  /** Verify the OTP. Creates the delivery customer account on first successful verification and returns a JWT. */
  verifyDeliveryOtp: DeliveryAuthPayload;
};


export type MutationAddLocationToShopArgs = {
  shop: ShopInput;
};


export type MutationAddShopArgs = {
  shop: ShopInput;
};


export type MutationAddStockArgs = {
  input: AddStockInput;
};


export type MutationAddUpdateCustomerArgs = {
  customer: CustomerInput;
};


export type MutationAddUpdateExpenseArgs = {
  expense: ExpenseInput;
};


export type MutationAddUpdateHairServiceArgs = {
  hairService: HairServiceInput;
};


export type MutationAddUpdateOrderArgs = {
  order: OrderInput;
};


export type MutationAddUpdateProductArgs = {
  product: ProductInput;
};


export type MutationAddUpdateUserArgs = {
  user: UserInput;
};


export type MutationAdjustInventoryArgs = {
  input: AdjustInventoryInput;
};


export type MutationCancelDeliveryOrderArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
};


export type MutationConfigureDeliveryLocationArgs = {
  input: DeliveryLocationConfigInput;
};


export type MutationConfirmDeliveryPaymentArgs = {
  razorpayPaymentId: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};


export type MutationCopyHairServicesArgs = {
  fromLocationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
  toLocationId: Scalars['String']['input'];
};


export type MutationDeleteCustomerArgs = {
  customerId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type MutationDeleteDeliveryAddressArgs = {
  addressId: Scalars['Int']['input'];
};


export type MutationDeleteExpenseArgs = {
  expenseId: Scalars['String']['input'];
};


export type MutationDeleteHairServiceArgs = {
  serviceId: Scalars['String']['input'];
};


export type MutationDeleteLocationArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type MutationDeleteOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeleteUserArgs = {
  shopId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationDeliveryPaymentCheckoutUrlArgs = {
  reference: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};


export type MutationDisconnectRazorpayArgs = {
  locationId: Scalars['String']['input'];
};


export type MutationGenerateOtpArgs = {
  phone: Scalars['String']['input'];
};


export type MutationGetMessagingQueueStatsArgs = {
  shopId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImpersonateUserArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  otp: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationPlaceDeliveryOrderArgs = {
  input: PlaceDeliveryOrderInput;
};


export type MutationQueueBillToWhatsAppArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};


export type MutationRegisterDeliveryDeviceArgs = {
  platform?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationRemoveBillLogoArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type MutationRequestDeliveryOtpArgs = {
  intent?: InputMaybe<DeliveryOtpIntent>;
  phone: Scalars['String']['input'];
};


export type MutationSaveBillSettingsArgs = {
  applyGstinToAllLocations?: Scalars['Boolean']['input'];
  input: BillSettingsInput;
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type MutationSaveDeliveryAddressArgs = {
  address: DeliveryAddressInput;
};


export type MutationSavePrinterNameArgs = {
  locationId: Scalars['String']['input'];
  printerName: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type MutationSaveProductCategoryArgs = {
  category: ProductCategoryInput;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetDefaultDeliveryAddressArgs = {
  addressId: Scalars['Int']['input'];
};


export type MutationSetDeliveryLocationEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  locationId: Scalars['String']['input'];
};


export type MutationStartRazorpayConnectArgs = {
  locationId: Scalars['String']['input'];
};


export type MutationSwitchShopArgs = {
  input: SwitchShopInput;
};


export type MutationToggleShopStatusArgs = {
  shopId: Scalars['String']['input'];
};


export type MutationUnregisterDeliveryDeviceArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateDeliveryCustomerProfileArgs = {
  input: DeliveryCustomerProfileInput;
};


export type MutationUpdateDeliveryOrderStatusArgs = {
  driverName?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdateLocationArgs = {
  location: ShopInput;
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type MutationUpdateShopArgs = {
  shop: ShopInput;
  shopId: Scalars['String']['input'];
};


export type MutationUploadBillLogoArgs = {
  dataUrl: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type MutationVerifyDeliveryOtpArgs = {
  otp: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type Order = {
  __typename?: 'Order';
  _id?: Maybe<Scalars['String']['output']>;
  billingUser: User;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId: Scalars['String']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  locationId: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  products: Array<OrderProduct>;
  sequenceNumber: Scalars['Float']['output'];
  services: Array<OrderService>;
  shopId: Scalars['String']['output'];
  stylistUserId?: Maybe<Scalars['String']['output']>;
  stylistUserName?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type OrderInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  products: Array<OrderProductInput>;
  sequenceNumber?: InputMaybe<Scalars['Float']['input']>;
  services: Array<OrderServiceInput>;
  shopId: Scalars['String']['input'];
  stylistUserId?: InputMaybe<Scalars['String']['input']>;
  stylistUserName?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderProduct = {
  __typename?: 'OrderProduct';
  _id?: Maybe<Scalars['String']['output']>;
  commissionPercentage?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<DiscountType>;
  discountValue?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  stylistUserId?: Maybe<Scalars['String']['output']>;
  stylistUserName?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type OrderProductInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<DiscountType>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  productId: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  stylistUserId?: InputMaybe<Scalars['String']['input']>;
  stylistUserName?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderService = {
  __typename?: 'OrderService';
  _id?: Maybe<Scalars['String']['output']>;
  commissionPercentage?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<DiscountType>;
  discountValue?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  serviceId: Scalars['String']['output'];
  stylistUserId?: Maybe<Scalars['String']['output']>;
  stylistUserName?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type OrderServiceInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<DiscountType>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  serviceId: Scalars['String']['input'];
  stylistUserId?: InputMaybe<Scalars['String']['input']>;
  stylistUserName?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type PaginatedCustomers = {
  __typename?: 'PaginatedCustomers';
  customers: Array<Customer>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedUserEvents = {
  __typename?: 'PaginatedUserEvents';
  events: Array<UserEvent>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum PaymentConnectionStatus {
  Active = 'ACTIVE',
  Disconnected = 'DISCONNECTED',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export enum PaymentProvider {
  Razorpay = 'RAZORPAY'
}

export type PaymentReport = {
  __typename?: 'PaymentReport';
  card: Scalars['Float']['output'];
  cash: Scalars['Float']['output'];
  upi: Scalars['Float']['output'];
};

export type PlaceDeliveryOrderInput = {
  addressId?: InputMaybe<Scalars['Int']['input']>;
  items: Array<DeliveryCartItemInput>;
  locationId: Scalars['String']['input'];
  orderType?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type Product = {
  __typename?: 'Product';
  availableQuantity?: Maybe<Scalars['Float']['output']>;
  categoryId?: Maybe<Scalars['Float']['output']>;
  commissionPercentage?: Maybe<Scalars['Float']['output']>;
  costPrice?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAvailableOnline?: Maybe<Scalars['Boolean']['output']>;
  isPerishable?: Maybe<Scalars['Boolean']['output']>;
  locationId: Scalars['String']['output'];
  maxOrderQuantity?: Maybe<Scalars['Float']['output']>;
  minOrderQuantity?: Maybe<Scalars['Float']['output']>;
  mongoReferenceId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nutritionInfo?: Maybe<Scalars['String']['output']>;
  preparationTime?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  shelfLifeDays?: Maybe<Scalars['Float']['output']>;
  shopId: Scalars['String']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  taxPercentage?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<ProductUnit>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['String']['output'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ProductCategoryInput = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type ProductInput = {
  availableQuantity?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  commissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  costPrice?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isPerishable?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['String']['input'];
  maxOrderQuantity?: InputMaybe<Scalars['Float']['input']>;
  minOrderQuantity?: InputMaybe<Scalars['Float']['input']>;
  mongoReferenceId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nutritionInfo?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  shelfLifeDays?: InputMaybe<Scalars['Float']['input']>;
  shopId: Scalars['String']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<ProductUnit>;
};

export enum ProductUnit {
  Gram = 'GRAM',
  Kg = 'KG',
  Liter = 'LITER',
  Ml = 'ML',
  Piece = 'PIECE'
}

export type Query = {
  __typename?: 'Query';
  /** A location's bill logo as a data URL, or null. */
  billLogo?: Maybe<Scalars['String']['output']>;
  /** The bill as HTML for a sample order with draft settings; nothing is saved. */
  billPreviewHtml: Scalars['String']['output'];
  /** A location's bill settings, defaults filled in. */
  billSettings: BillSettings;
  /** What each business kind means when a location has no overrides. */
  businessProfilePresets: Array<BusinessProfilePreset>;
  checkStockAvailability: Scalars['Boolean']['output'];
  commissionReport: CommissionReportSummary;
  customer: Customer;
  customerList: PaginatedCustomers;
  /** @deprecated Use customerList, which pages, searches and checks location access. */
  customers: Array<Customer>;
  /** The signed-in delivery customer's saved addresses, default first. */
  deliveryAddresses: Array<DeliveryAddress>;
  /** Categories that have at least one deliverable product at this location, in display order. Empty categories are omitted so every filter chip returns something. */
  deliveryCategories: Array<ProductCategory>;
  /** The signed-in delivery customer. Requires a delivery customer token. */
  deliveryCustomerMe: DeliveryCustomer;
  /** A location's delivery settings, or null when delivery has never been configured for it. */
  deliveryLocationConfig?: Maybe<DeliveryLocation>;
  /** Delivery settings for every configured location of a shop. Locations that have never been configured are simply absent, so the caller sees 'not set up' as a missing row rather than a null. */
  deliveryLocationsForShop: Array<DeliveryLocation>;
  /** One order for tracking. Polled by the app; there is no websocket transport here. */
  deliveryOrder: DeliveryOrder;
  /** Delivery orders at a location, newest first, optionally filtered by status. */
  deliveryOrdersForLocation: Array<DeliveryOrder>;
  /** A single deliverable product, subject to the same visibility rule as the list. */
  deliveryProduct: DeliveryProduct;
  /** Deliverable products at a serving location, in-stock first then alphabetical. Optionally filtered by category and by a case-insensitive name search. Out-of-stock products are included and flagged rather than hidden. */
  deliveryProducts: DeliveryProductPage;
  expense?: Maybe<Expense>;
  expenses: Array<Expense>;
  getUserCurrentShopDetails: Shop;
  getUserShopAccess: Array<Shop>;
  hairservice?: Maybe<HairService>;
  hairservices: Array<HairService>;
  inventories: Array<Inventory>;
  inventory?: Maybe<Inventory>;
  inventoryTransactions: Array<InventoryTransaction>;
  lowStockItems: Array<Inventory>;
  /** Order history, newest first. In-store orders never appear: they live in MongoDB. */
  myDeliveryOrders: Array<DeliveryOrder>;
  order: Order;
  orders: Array<Order>;
  ordersByCustomer: Array<Order>;
  printerName: Scalars['String']['output'];
  product?: Maybe<Product>;
  productCategories: Array<ProductCategory>;
  products: Array<Product>;
  report: Report;
  searchCustomerByPhoneNumber: Array<Customer>;
  /** Locations that deliver to the given coordinate, nearest first, each with its distance and delivery fee. Omit the coordinate to list every delivery-enabled location instead, for a client that has no customer address yet. */
  serviceableDeliveryLocations: Array<ServiceableLocation>;
  shops: Array<Shop>;
  user?: Maybe<User>;
  userEvent?: Maybe<UserEvent>;
  userEvents: PaginatedUserEvents;
  users: Array<User>;
  verifyjwt: Scalars['Boolean']['output'];
};


export type QueryBillLogoArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryBillPreviewHtmlArgs = {
  input: BillSettingsInput;
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryBillSettingsArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryCheckStockAvailabilityArgs = {
  locationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryCommissionReportArgs = {
  query: SearchInput;
};


export type QueryCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryCustomerListArgs = {
  input: CustomerListInput;
};


export type QueryCustomersArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryDeliveryCategoriesArgs = {
  locationId: Scalars['String']['input'];
};


export type QueryDeliveryLocationConfigArgs = {
  locationId: Scalars['String']['input'];
};


export type QueryDeliveryLocationsForShopArgs = {
  shopId: Scalars['String']['input'];
};


export type QueryDeliveryOrderArgs = {
  reference: Scalars['String']['input'];
};


export type QueryDeliveryOrdersForLocationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDeliveryProductArgs = {
  locationId: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};


export type QueryDeliveryProductsArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExpenseArgs = {
  _id: Scalars['String']['input'];
};


export type QueryExpensesArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryGetUserCurrentShopDetailsArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryHairserviceArgs = {
  _id: Scalars['String']['input'];
};


export type QueryHairservicesArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryInventoriesArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryInventoryArgs = {
  locationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryInventoryTransactionsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  locationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryLowStockItemsArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryMyDeliveryOrdersArgs = {
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


export type QueryOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryOrdersArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  query: SearchInput;
  shopId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersByCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryPrinterNameArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryProductArgs = {
  id: Scalars['Float']['input'];
};


export type QueryProductCategoriesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductsArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryReportArgs = {
  query: SearchInput;
};


export type QuerySearchCustomerByPhoneNumberArgs = {
  locationId: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryServiceableDeliveryLocationsArgs = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryShopsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUserArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryUserEventArgs = {
  eventId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};


export type QueryUserEventsArgs = {
  input: GetUserEventsInput;
};


export type QueryUsersArgs = {
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};

export enum ReceiptPaper {
  A4 = 'A4',
  Thermal_58 = 'THERMAL_58',
  Thermal_80 = 'THERMAL_80'
}

export type Report = {
  __typename?: 'Report';
  comparisonMetrics: ComparisonMetrics;
  dailySales: Array<TimeSeriesDataPoint>;
  inventoryAnalysis: Array<InventoryAnalysisItem>;
  lowStockCount: Scalars['Float']['output'];
  monthlySales: Array<TimeSeriesDataPoint>;
  orders: Array<Order>;
  overstockCount: Scalars['Float']['output'];
  paymentReport: PaymentReport;
  productCategories: Array<CategoryRevenue>;
  serviceCategories: Array<CategoryRevenue>;
  staffPerformance: Array<StaffPerformance>;
  totalCustomers: Scalars['Float']['output'];
  totalDiscount: Scalars['Float']['output'];
  totalExistingCustomers: Scalars['Float']['output'];
  totalNewCustomers: Scalars['Float']['output'];
  totalProductDiscount: Scalars['Float']['output'];
  totalProductSales: Scalars['Float']['output'];
  totalSales: Scalars['Float']['output'];
  totalServiceDiscount: Scalars['Float']['output'];
  totalServiceSales: Scalars['Float']['output'];
  weeklySales: Array<TimeSeriesDataPoint>;
};

export type SearchInput = {
  endDate: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  stylistUserId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceableLocation = {
  __typename?: 'ServiceableLocation';
  acceptsCashOnDelivery: Scalars['Boolean']['output'];
  acceptsOnlinePayment: Scalars['Boolean']['output'];
  businessType: BusinessType;
  city?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  distanceKm?: Maybe<Scalars['Float']['output']>;
  estimatedMinutes?: Maybe<Scalars['Int']['output']>;
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
  shopId: Scalars['String']['output'];
  shopName: Scalars['String']['output'];
};

export type Shop = {
  __typename?: 'Shop';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  location: Array<Location>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ShopInput = {
  location: Array<LocationBase>;
  name?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
};

export enum StaffPerLine {
  Off = 'OFF',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export type StaffPerformance = {
  __typename?: 'StaffPerformance';
  averageOrderValue: Scalars['Float']['output'];
  orderCount: Scalars['Float']['output'];
  productRevenue: Scalars['Float']['output'];
  serviceRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

/** Stock level status indicators */
export enum StockStatus {
  CriticalLow = 'CRITICAL_LOW',
  Low = 'LOW',
  Normal = 'NORMAL',
  Overstock = 'OVERSTOCK'
}

export type StylistCommissionReport = {
  __typename?: 'StylistCommissionReport';
  productCommissions: Array<StylistProductCommission>;
  serviceCommissions: Array<StylistServiceCommission>;
  stylistName: Scalars['String']['output'];
  stylistUserId: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  totalCommission: Scalars['Float']['output'];
  totalOrders: Scalars['Float']['output'];
  totalProductAmount: Scalars['Float']['output'];
  totalProductCommission: Scalars['Float']['output'];
  totalServiceAmount: Scalars['Float']['output'];
  totalServiceCommission: Scalars['Float']['output'];
};

export type StylistProductCommission = {
  __typename?: 'StylistProductCommission';
  commissionAmount: Scalars['Float']['output'];
  commissionPercentage: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type StylistServiceCommission = {
  __typename?: 'StylistServiceCommission';
  commissionAmount: Scalars['Float']['output'];
  commissionPercentage: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  serviceId: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type SwitchShopInput = {
  fromLocationId: Scalars['String']['input'];
  fromShopId: Scalars['String']['input'];
  toLocationId: Scalars['String']['input'];
  toShopId: Scalars['String']['input'];
};

export type TimeSeriesDataPoint = {
  __typename?: 'TimeSeriesDataPoint';
  date: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type User = {
  __typename?: 'User';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  roles: Array<UserRole>;
  shopId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type UserEvent = {
  __typename?: 'UserEvent';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  fromLocationId?: Maybe<Scalars['String']['output']>;
  fromLocationName?: Maybe<Scalars['String']['output']>;
  fromShopId?: Maybe<Scalars['String']['output']>;
  fromShopName?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  shopId?: Maybe<Scalars['String']['output']>;
  shopName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export enum UserEventType {
  CustomerCreate = 'CUSTOMER_CREATE',
  CustomerUpdate = 'CUSTOMER_UPDATE',
  ExpenseCreate = 'EXPENSE_CREATE',
  ExpenseUpdate = 'EXPENSE_UPDATE',
  LocationUpdate = 'LOCATION_UPDATE',
  OrderCreate = 'ORDER_CREATE',
  OrderUpdate = 'ORDER_UPDATE',
  ProductCreate = 'PRODUCT_CREATE',
  ProductUpdate = 'PRODUCT_UPDATE',
  ServiceCreate = 'SERVICE_CREATE',
  ServiceUpdate = 'SERVICE_UPDATE',
  ShopSwitch = 'SHOP_SWITCH',
  ShopUpdate = 'SHOP_UPDATE',
  UserLogin = 'USER_LOGIN',
  UserLogout = 'USER_LOGOUT',
  WhatsappOrderFailed = 'WHATSAPP_ORDER_FAILED',
  WhatsappOrderSent = 'WHATSAPP_ORDER_SENT'
}

export type UserInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  roles: Array<UserRoleInput>;
  shopId: Scalars['String']['input'];
};

export type UserRole = {
  __typename?: 'UserRole';
  locationId?: Maybe<Scalars['String']['output']>;
  role: UserType;
};

export type UserRoleInput = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  role: UserType;
};

export enum UserType {
  LocationAdmin = 'LOCATION_ADMIN',
  LocationBillingUser = 'LOCATION_BILLING_USER',
  LocationUser = 'LOCATION_USER',
  ShopAdmin = 'SHOP_ADMIN',
  SuperAdmin = 'SUPER_ADMIN'
}

export type JwtMutationVariables = Exact<{
  phone: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}>;


export type JwtMutation = { __typename?: 'Mutation', login?: string | null };

export type GetShopAccessForLocationSwitchQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopAccessForLocationSwitchQuery = { __typename?: 'Query', getUserShopAccess: Array<{ __typename?: 'Shop', _id?: string | null, name: string, location: Array<{ __typename?: 'Location', _id?: string | null, name: string, businessType?: BusinessType | null, currency: string, address: { __typename?: 'Address', city: string }, profile: { __typename?: 'BusinessProfile', staffPerLine: StaffPerLine, staffLabel: string, servicesEnabled: boolean, servicesLabel: string } }> }> };

export type GetProductCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCategoriesQuery = { __typename?: 'Query', productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string }> };

export type InventoryQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type InventoryQuery = { __typename?: 'Query', inventory?: { __typename?: 'Inventory', id: number, productId: string, shopId: string, locationId: string, quantityOnHand: number, quantityReserved: number, quantityAvailable: number, reorderLevel: number, reorderQuantity: number, lastRestockedAt?: any | null } | null };

export type InventoryTransactionsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;


export type InventoryTransactionsQuery = { __typename?: 'Query', inventoryTransactions: Array<{ __typename?: 'InventoryTransaction', id: number, transactionType: string, quantityChange: number, quantityBefore: number, quantityAfter: number, referenceType?: string | null, referenceId?: string | null, notes?: string | null, createdBy?: string | null, createdAt: any }> };

export type AddStockMutationVariables = Exact<{
  input: AddStockInput;
}>;


export type AddStockMutation = { __typename?: 'Mutation', addStock: { __typename?: 'Inventory', id: number, quantityOnHand: number } };

export type AdjustInventoryMutationVariables = Exact<{
  input: AdjustInventoryInput;
}>;


export type AdjustInventoryMutation = { __typename?: 'Mutation', adjustInventory: { __typename?: 'Inventory', id: number, quantityOnHand: number } };

export type GetUserShopAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserShopAccessQuery = { __typename?: 'Query', getUserShopAccess: Array<{ __typename?: 'Shop', _id?: string | null, name: string, location: Array<{ __typename?: 'Location', _id?: string | null, address: { __typename?: 'Address', city: string } }> }> };

export type DeliveryOrdersForLocationQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  statuses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeliveryOrdersForLocationQuery = { __typename?: 'Query', deliveryOrdersForLocation: Array<{ __typename?: 'DeliveryOrder', id: number, reference: string, status: string, orderType: string, paymentMethod: string, subtotal: number, taxAmount: number, deliveryFee: number, total: number, distanceKm?: number | null, estimatedMinutes?: number | null, addressSnapshot?: string | null, driverName?: string | null, cancellationReason?: string | null, placedAt: any, customerName?: string | null, customerPhone?: string | null, payment?: { __typename?: 'DeliveryPayment', status: DeliveryPaymentStatus, method?: string | null, amount: number } | null, items: Array<{ __typename?: 'DeliveryOrderItem', id: number, productName: string, unit: string, unitPrice: number, quantity: number, lineTotal: number }> }> };

export type UpdateDeliveryOrderStatusMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  status: Scalars['String']['input'];
  driverName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDeliveryOrderStatusMutation = { __typename?: 'Mutation', updateDeliveryOrderStatus: { __typename?: 'DeliveryOrder', id: number, status: string, driverName?: string | null } };

export type ListProductCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListProductCategoriesQuery = { __typename?: 'Query', productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, slug: string, displayOrder: number, isActive: boolean }> };

export type SaveProductCategoryMutationVariables = Exact<{
  category: ProductCategoryInput;
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SaveProductCategoryMutation = { __typename?: 'Mutation', saveProductCategory: { __typename?: 'ProductCategory', id: number, name: string, slug: string, displayOrder: number, isActive: boolean } };

export type GetProductByIdQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type GetProductByIdQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id?: number | null, sku?: string | null, name: string, description?: string | null, quantity?: number | null, categoryId?: number | null, shopId: string, locationId: string, unit?: ProductUnit | null, price?: number | null, costPrice?: number | null, taxPercentage?: number | null, isPerishable?: boolean | null, shelfLifeDays?: number | null, images?: Array<string> | null, isActive?: boolean | null, isAvailableOnline?: boolean | null, minOrderQuantity?: number | null, maxOrderQuantity?: number | null, preparationTime?: number | null, tags?: Array<string> | null, nutritionInfo?: string | null, commissionPercentage?: number | null } | null };

export type AddUpdateProductMutationVariables = Exact<{
  product: ProductInput;
}>;


export type AddUpdateProductMutation = { __typename?: 'Mutation', addUpdateProduct?: { __typename?: 'Product', id?: number | null, name: string } | null };

export type HairserviceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type HairserviceQuery = { __typename?: 'Query', hairservice?: { __typename?: 'HairService', _id?: string | null, name: string, price: number, duration_minutes: number, description: string, taxPercentage?: number | null, commissionPercentage?: number | null, shopId: string, locationId: string } | null };

export type AddUpdateHairServiceMutationVariables = Exact<{
  hairService: HairServiceInput;
}>;


export type AddUpdateHairServiceMutation = { __typename?: 'Mutation', addUpdateHairService?: { __typename?: 'HairService', _id?: string | null, name: string } | null };

export type GenerateOptMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type GenerateOptMutation = { __typename?: 'Mutation', generateOtp: boolean };


export const JwtDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"jwt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"otp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otp"}}}]}]}}]} as unknown as DocumentNode<JwtMutation, JwtMutationVariables>;
export const GetShopAccessForLocationSwitchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShopAccessForLocationSwitch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserShopAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessType"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffPerLine"}},{"kind":"Field","name":{"kind":"Name","value":"staffLabel"}},{"kind":"Field","name":{"kind":"Name","value":"servicesEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"servicesLabel"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetShopAccessForLocationSwitchQuery, GetShopAccessForLocationSwitchQueryVariables>;
export const GetProductCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProductCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>;
export const InventoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"inventory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"shopId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"quantityOnHand"}},{"kind":"Field","name":{"kind":"Name","value":"quantityReserved"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"reorderLevel"}},{"kind":"Field","name":{"kind":"Name","value":"reorderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"lastRestockedAt"}}]}}]}}]} as unknown as DocumentNode<InventoryQuery, InventoryQueryVariables>;
export const InventoryTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"inventoryTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventoryTransactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"quantityChange"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBefore"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAfter"}},{"kind":"Field","name":{"kind":"Name","value":"referenceType"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<InventoryTransactionsQuery, InventoryTransactionsQueryVariables>;
export const AddStockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addStock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddStockInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addStock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantityOnHand"}}]}}]}}]} as unknown as DocumentNode<AddStockMutation, AddStockMutationVariables>;
export const AdjustInventoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"adjustInventory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdjustInventoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adjustInventory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantityOnHand"}}]}}]}}]} as unknown as DocumentNode<AdjustInventoryMutation, AdjustInventoryMutationVariables>;
export const GetUserShopAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserShopAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserShopAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserShopAccessQuery, GetUserShopAccessQueryVariables>;
export const DeliveryOrdersForLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"deliveryOrdersForLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryOrdersForLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryFee"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"distanceKm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"addressSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"driverName"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"placedAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhone"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"lineTotal"}}]}}]}}]}}]} as unknown as DocumentNode<DeliveryOrdersForLocationQuery, DeliveryOrdersForLocationQueryVariables>;
export const UpdateDeliveryOrderStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDeliveryOrderStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeliveryOrderStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"driverName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"driverName"}}]}}]}}]} as unknown as DocumentNode<UpdateDeliveryOrderStatusMutation, UpdateDeliveryOrderStatusMutationVariables>;
export const ListProductCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listProductCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeInactive"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<ListProductCategoriesQuery, ListProductCategoriesQueryVariables>;
export const SaveProductCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveProductCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCategoryInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveProductCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<SaveProductCategoryMutation, SaveProductCategoryMutationVariables>;
export const GetProductByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProductById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"shopId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"costPrice"}},{"kind":"Field","name":{"kind":"Name","value":"taxPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"isPerishable"}},{"kind":"Field","name":{"kind":"Name","value":"shelfLifeDays"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableOnline"}},{"kind":"Field","name":{"kind":"Name","value":"minOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"maxOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"preparationTime"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"nutritionInfo"}},{"kind":"Field","name":{"kind":"Name","value":"commissionPercentage"}}]}}]}}]} as unknown as DocumentNode<GetProductByIdQuery, GetProductByIdQueryVariables>;
export const AddUpdateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUpdateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUpdateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AddUpdateProductMutation, AddUpdateProductMutationVariables>;
export const HairserviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hairservice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hairservice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"taxPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"commissionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"shopId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}}]}}]}}]} as unknown as DocumentNode<HairserviceQuery, HairserviceQueryVariables>;
export const AddUpdateHairServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUpdateHairService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hairService"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HairServiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUpdateHairService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hairService"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hairService"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AddUpdateHairServiceMutation, AddUpdateHairServiceMutationVariables>;
export const GenerateOptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateOPT"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateOtp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}}]}]}}]} as unknown as DocumentNode<GenerateOptMutation, GenerateOptMutationVariables>;